<template>
  <div class="page-contact-pro">
    <section class="page-contact-pro__form-section">
      <div class="form-section container">
        <h1 class="form-section__title">
          Dagelijks koppelen wij aanvragen van particulieren en bedrijven aan
          onze professionals. Sluit je nu aan als pro!
        </h1>

        <div class="form-section__wrapper">
          <div class="form-section__column form-section__form">
            <div class="form__container container">
              <h2 class="form__title">
                Vraag een gratis informatiegesprek aan!
              </h2>

              <ContactProForm
                confirmation-path="/contact-opnemen-bedrijf/bevestigd"
              />
            </div>
          </div>

          <div class="form-section__column form-section__info">
            <MapNetherlands text="heeft een rijschool nodig." />

            <p class="info__body">
              Elke dag zijn meer dan 1000 particulieren en bedrijven op zoek
              naar onze professionals
            </p>
          </div>
        </div>
      </div>
    </section>

    <div class="page-contact-pro__usps">
      <div class="container">
        <h2 class="usps__title">Wij bieden jou nieuwe klanten aan</h2>
        <p class="usps__body">
          Profiteer van het voordeel van een alles-in-één marketingoplossing.
          Wij helpen jouw klantenbestand groeien.
        </p>

        <Usps :columns="usps.length" :usps="usps" />
      </div>
    </div>
  </div>
</template>

<script>
import ContactProForm from 'chimera/all/components/form/contact/ContactProForm'
import Usps from 'chimera/all/themes/blueflow/components/Usps'
import MapNetherlands from 'chimera/all/components/lottie/MapNetherlands'
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  name: 'ContactProPage',

  components: {
    ContactProForm,
    Usps,
    MapNetherlands,
  },

  extends: AbstractPage,

  layout: 'contact-pro',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Aanmelden als partner',
      headDescription:
        'Wil je ook leads ontvangen van Rijscholenvergelijker.nl? Meld je dan aan via het contactformulier. Contact opnemen met geïnteresseerden in jouw regio is mogelijk!',
      path: '/contact-opnemen-bedrijf',
      usps: [
        {
          text: 'Potentiële klanten uit jouw eigen werkgebied!',
          logo: require('chimera/all/themes/blueflow/images/usps/place.svg'),
        },
        {
          text: 'Bepaal zelf hoeveel aanvragen je wilt ontvangen.',
          logo: require('chimera/all/themes/blueflow/images/usps/shopping-cart.svg'),
        },
        {
          text: 'Ontvang kwalitatieve offerte aanvragen.',
          logo: require('chimera/all/themes/blueflow/images/usps/offer.svg'),
        },
        {
          text: 'Gratis inschrijven en geen contractduur.',
          logo: require('chimera/all/themes/blueflow/images/usps/wallet.svg'),
        },
      ],
    }
  },
}
</script>
